<template>
  <div>
    <div class="module-title">商户估价系数设置</div>
    <div class="flex mb-10">
      <img src="@/assets/images/ico_ts_red.png" style="margin-right: 8px" />
      <span class="tip-color">说明：商户默认使用系统估价，各商户可根据合作回收商报价高低与系统报价进行对比，若系统出价相对于回收商价格较高，可适当调低。若线上回收运营需使用较高预估价吸引顾客到店，系数可设置大于1，提前向店员培训相关的话术以免造成误解。</span>
    </div>
    <div class="flex mb-10">
      <span style="font-size:15px;color:#333">商户估价 = 系统估价 × </span>
      <el-input
        class="factor-rate"
        v-model.trim="factorRate"
        @input="limitInput($event, 'factorRate', 'this')"
        size="mini"
      ></el-input>
    </div>
    <div class="line"></div>
    <div class="module-title">用户预估价设置</div>
    <div class="set-title">计算方式</div>
    <el-radio-group v-model="usePayConfig" class="radio-group ml-10">
      <div class="radio-item">
        <el-radio :label="true">扣减利润红包</el-radio>
        <div>用户显示预估价=商户预估价-利润-红包</div>
        <el-button
          type="text"
          style="padding:0;text-decoration: underline;margin-left:20px"
          @click="seeProfit"
          >查看公司利润设置</el-button
        >
      </div>
      <div class="radio-item">
        <el-radio :label="false">不扣减利润红包</el-radio>  
        <div>用户显示预估价=商户预估价</div>
      </div>
    </el-radio-group>
    <div class="set-title">显示方式</div>
    <el-radio-group v-model="showPriceType" class="ml-10 mb-10">
      <div style="display:flex">
        <el-radio label="01">按精确值</el-radio>
        <el-link type="info" class="mr-40" style="text-decoration: underline" @click="preview('https://img.fanxinghuishou.cn/20240514/302233450.png')">查看示例</el-link>
        <el-radio label="02">按范围区间</el-radio>
        <el-link type="info" style="text-decoration: underline" @click="preview('https://img.fanxinghuishou.cn/20240514/803233608.png')">查看示例</el-link>
      </div>
    </el-radio-group>
    <div v-if="showPriceType == '02'">
      <div class="rule-title">
        预估价范围设置
        <el-button type="primary" size="small" @click="$refs['futureRuleDia'].open()">添加规则</el-button>
      </div>
      <el-table :data="userPriceShowRegionList" border size="small">
        <el-table-column type="index" width="100" align="center" label="序号">
        </el-table-column>
        <el-table-column label="用户预估价" prop="region" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lower }}≤区间＜{{ row.upper }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="预估价范围左区间值下调比例" prop="leftSideRatio">
          <template slot-scope="{row}">
            <span>{{ row.leftSideRatio }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="最多下调" prop="leftSideLimit" align="center" />
        <el-table-column align="center" label="预估价范围右区间值上调比例" prop="rightSideRatio">
          <template slot-scope="{row}">
              <span>{{ row.rightSideRatio }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="最多上调" prop="rightSideLimit" align="center"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              size="small"
              @click="$refs['futureRuleDia'].open(scope.row)"
              type="primary"
              >编辑</el-button
            >
            <el-button
              size="small"
              @click="delItem(scope.$index)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="mt-10">
      <el-button :loading="btnLoading" type="primary" @click="save(false)">提交次日生效</el-button>
      <el-button :loading="btnLoading" type="warning" @click="save(true)">提交立即生效</el-button>
    </div> -->
    <FutureRuleDia ref="futureRuleDia" @confirm="ruleChangeHandler" />
    <el-dialog
      title="公司回收利润及员工红包设置"
      :visible.sync="dialogProfitVisible"
      :close-on-click-modal="false"
      width="800px"
      @close="radioProfit = '01'"
    >
      <div class="mb-20">
        <el-radio-group v-model="radioProfit">
          <el-radio-button label="01">公司利润</el-radio-button>
          <el-radio-button label="02">员工红包</el-radio-button>
        </el-radio-group>
      </div>
      <GlobalTable
        v-if="radioProfit == '01'"
        ref="GlobalTable"
        myKey="radioProfit01"
        :columns="rebateColumns"
        :data="
          rebateRegionList.slice(
            (rebatePage.pageNum - 1) * rebatePage.pageSize,
            rebatePage.pageNum * rebatePage.pageSize
          )
        "
        :currentPage="rebatePage.pageNum"
        :total="rebateRegionList.length"
        :pageSize="rebatePage.pageSize"
        @handleCurrentChange="rebateHandleCurrentChange"
      >
        <el-table-column label="报价区间" slot="rank" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lower }}≤区间＜{{ row.upper }}</span>
          </template>
        </el-table-column>
        <el-table-column label="门店返利" slot="rebate" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.rebate }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          label="门店返利上限"
          slot="rebateLimit"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>￥{{ row.rebateLimit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预留返利" slot="delayRebate" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.delayRebate }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          label="预留返利上限"
          slot="delayRebateLimit"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>￥{{ row.delayRebateLimit }}</span>
          </template>
        </el-table-column>
      </GlobalTable>
      <GlobalTable
        v-if="radioProfit == '02'"
        ref="GlobalTable"
        myKey="radioProfit02"
        :columns="redPacketColumns"
        :data="
          apRegionList.slice(
            (redPacketPage.pageNum - 1) * redPacketPage.pageSize,
            redPacketPage.pageNum * redPacketPage.pageSize
          )
        "
        :currentPage="redPacketPage.pageNum"
        :total="apRegionList.length"
        :pageSize="redPacketPage.pageSize"
        @handleCurrentChange="redHandleCurrentChange"
      >
        <el-table-column label="报价区间" slot="rank" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lower }}≤区间＜{{ row.upper }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="店长红包"
          slot="shopownerReward"
          align="center"
        >
          <template slot-scope="{ row }">
            <span
              >{{ row.rebateType == "02" ? "￥" : "" }}{{ row.shopownerReward
              }}{{ row.rebateType == "01" ? "%" : "" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="店长红包上限"
          slot="shopownerRewardLimit"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>￥{{ row.shopownerRewardLimit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="店员红包" slot="clerkReward" align="center">
          <template slot-scope="{ row }">
            <span
              >{{ row.rebateType == "02" ? "￥" : "" }}{{ row.clerkReward
              }}{{ row.rebateType == "01" ? "%" : "" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="店员红包上限"
          slot="clerkRewardLimit"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>￥{{ row.clerkRewardLimit }}</span>
          </template>
        </el-table-column>
      </GlobalTable>
    </el-dialog>
    <el-image-viewer v-if="showViewer" :on-close="() => { showViewer = false }" :url-list="imgList"/>
  </div>
</template>

<script>
import _api from "@/utils/request";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import FutureRuleDia from './dialog/FutureRuleDia.vue'
export default {
  components: { ElImageViewer, FutureRuleDia },
  props: {
    config: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      dialogProfitVisible: false,
      btnLoading: false,

      radioProfit: "01",
      rebateRegionList: [],
      apRegionList: [],
      rebatePage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      redPacketPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      rebateColumns: [
        { slotName: "rank" },
        { slotName: "rebate" },
        { slotName: "rebateLimit" },
        { slotName: "delayRebate" },
        { slotName: "delayRebateLimit" },
      ],
      redPacketColumns: [
        { slotName: "rank" },
        { slotName: "shopownerReward" },
        { slotName: "shopownerRewardLimit" },
        { slotName: "clerkReward" },
        { slotName: "clerkRewardLimit" },
      ],

      factorRate: "1",
      usePayConfig: true,
      showPriceType: '01',
      userPriceShowRegionList: [],

      imgList: [],
      showViewer: false,
    }
  },
  watch: {
    config: {
      handler(v) {
        if (v) {
          this.factorRate = v.factorRate
          this.usePayConfig = v.usePayConfig
          this.showPriceType = v.showPriceType
          this.userPriceShowRegionList = (v.userPriceShowRegionList || []).map(item => {
            item._t = Math.random()
            return item
          })
        }
      },
      immediate: true
    }
  },
  created() {
    this.configInfo();
  },
  methods: {
    // 获取平台支付配置详情
    configInfo() {
      _api.configInfo().then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.rebateRegionList = res.data.rebateRegionList;
          this.apRegionList = res.data.apRegionList;
        }
      });
    },
    // 获取配置详情
    // getPayconfig() {
    //   _api.getPayconfig().then((res) => {
    //     if (res.code == 1) {
    //       if (res.data) {
    //         this.factorRate = res.data.factorRate;
    //         this.rewardExpire = res.data.rewardExpire + "";
    //         this.usePayConfig = res.data.usePayConfig;
    //         this.redPacketRuleList = res.data.regionDtoList;
    //         this.showPriceType = res.data.showPriceType
    //         this.userPriceShowRegionList = res.data.userPriceShowRegionList || []
    //       }
    //     }
    //   });
    // },
    seeProfit() {
      this.dialogProfitVisible = true;
    },
    rebateHandleCurrentChange(val) {
      this.rebatePage.pageNum = val;
    },
    redHandleCurrentChange(val) {
      this.redPacketPage.pageNum = val;
    },
    ruleChangeHandler(type, ruleItem) {
      if (type == 'add') {
        this.userPriceShowRegionList.push({ ...ruleItem, _t: Math.random()})
      } else {
        const { id, _t } = ruleItem
        const itemIndex = this.userPriceShowRegionList.findIndex(item => {
          if (id) return item.id === id
          return _t === item._t
        })
        this.$set(this.userPriceShowRegionList, itemIndex, ruleItem)
      }
    },
    delItem(i) {
      this.userPriceShowRegionList.splice(i, 1)
    },
    save(isImmediate) {
      _api.savePayconfig({
        factorRate: this.factorRate,
        usePayConfig: this.usePayConfig,
        showPriceType: this.showPriceType,
        userPriceShowRegionList: this.userPriceShowRegionList,
        isImmediate
      }).then(res => {
        this.$message.success("操作成功");
        this.getPayconfig()
      }).finally(() => {
        this.btnLoading = false
      })
    },
    getParams() {
      return {
        factorRate: this.factorRate,
        usePayConfig: this.usePayConfig,
        showPriceType: this.showPriceType,
        userPriceShowRegionList: this.userPriceShowRegionList,
      }
    },
    preview(url) {
      this.imgList = [url]
      this.showViewer = true
    }
  }
}
</script>

<style lang="scss" scoped>
.module-title {
  font-size: 16px;
  color: #000000;
  font-weight: bold;
  margin-bottom: 20px;
}
.set-title {
  font-weight: bold;
  color: #333333;
  font-size: 16px;
  height: 16px;
  padding-left: 10px;
  border-left: 3px solid #0981ff;
  margin-bottom: 15px;

  display: flex;
  align-items: center;
}
.set-title-little {
  position: relative;
  color: #333333;
  font-size: 16px;
  margin-bottom: 10px;
}
.set-title-little::before {
  content: "";
  display: block;
  width: 64px;
  height: 6px;
  background: linear-gradient(
    to right,
    rgba(255, 175, 41, 0.61) 39%,
    rgba(255, 175, 41, 0) 100%
  );
  opacity: 0.65;
  border-radius: 3px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.line {
  height: 1px;
  background: #edeffd;
  margin-bottom: 20px;
}
.tip-color {
  color: #ff687b;
  font-size: 12px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.mr-10 {
  margin-right: 10px;
}
.mr-40 {
  margin-right: 40px;
}
.mt-10 {
  margin-top: 10px;
}
.flex {
  display: flex;
  align-items: center;
}
.flex-jb {
  display: flex;
  justify-content: space-between;
}
.flex-jc {
  display: flex;
  justify-content: center;
}

.factor-rate {
  width: 40px;
  margin-left: 5px;
}
/deep/.factor-rate .el-input__inner {
  padding: 0 5px;
  text-align: center;
}
/deep/.demo-ruleForm .el-form-item__content .el-input-group {
  vertical-align: middle;
}

.radio-group{
  margin-bottom: 10px;
  // padding-left: 10px;
  margin-bottom: 15px;
  .radio-item{
    display: flex;
    align-items: center;
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
    &>div {
      font-size: 14px;
    }
  }
}
.rule-title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
</style>